import { FC, Fragment } from "react";
import { UserMultiSelectField } from "../../ui/UserMultiSelectField";
import { EventFormColumns } from "./EventFormColumns";
import { useEventTypeField } from "./useEventTypeField";

export const EventUsersStepFormFields: FC = () => {
	const eventType = useEventTypeField();

	return (
		<EventFormColumns>
			{eventType?.userResponsibilityRequirements.map(({ requirement, userResponsibility }) => (
				<Fragment key={userResponsibility.id}>
					{requirement !== "prohibited" && (
						<UserMultiSelectField
							name={`eventUsers.${userResponsibility.id}`}
							label={userResponsibility.name}
							required={requirement === "required"}
						/>
					)}
				</Fragment>
			))}
		</EventFormColumns>
	);
};
